export const SIDE_EFFECT_QUESTIONS = {
  akathisia: {
    answer: false,
    label: "Akathisia",
    order: 18,
  },
  anxiety: {
    answer: false,
    label: "Anxiety",
    order: 1,
  },
  bradykinesia: {
    answer: false,
    label: "Bradykinesia",
    order: 16,
  },
  constipation: {
    answer: false,
    label: "Constipation",
    order: 9,
  },
  daytime_sleepiness: {
    answer: false,
    label: "Excessive Daytime Sleepiness",
    order: 13,
  },
  depression: {
    answer: false,
    label: "Depression",
    order: 3,
  },
  diarrhea: {
    answer: false,
    label: "Diarrhea",
    order: 7,
  },
  discontinuation: {
    answer: false,
    label: "Discontinuation Syndrome",
    order: 19,
  },
  increased_appetite: {
    answer: false,
    label: "Increased Appetite",
    order: 2,
  },
  increased_cholesterol: {
    answer: false,
    label: "Increased Cholesterol",
    order: 10,
  },
  increased_glucose: {
    answer: false,
    label: "Increased Glucose",
    order: 8,
  },
  insomnia: {
    answer: false,
    label: "Insomnia",
    order: 17,
  },
  movement_disorders: {
    answer: false,
    label: "Movement Disorders",
    order: 12,
  },
  nausea: {
    answer: false,
    label: "Nausea",
    order: 5,
  },
  none: {
    label: "None",
    order: 20,
    value: true,
  },
  sedation: {
    answer: false,
    label: "Sedation",
    order: 15,
  },
  sexual: {
    answer: false,
    label: "Sexual Side Effects",
    order: 11,
  },
  tremors: {
    answer: false,
    label: "Tremors",
    order: 14,
  },
  weight_gain: {
    answer: false,
    label: "Weight Gain",
    order: 4,
  },
  weight_loss: {
    answer: false,
    label: "Weight Loss",
    order: 6,
  },
};
